import { ArdoqId, APIEntityType } from '@ardoq/api-types';
import { OtherLabelsData } from './types';
import { getRelevantLabelFormatting } from './otherLabelUtils';
import { fieldLabel } from './labelFormattingLabels';
import { LabelsInterface } from '../labelsInterface/labelsInterface';
import { type I18nLocale } from '@ardoq/i18n';

/**
 * Get the first label formatting which is relevant for the entity, and returns the old-fashion-formatted
 * string []
 */
export const getFirstFormattedMultiLabel = (
  labelsInterface: LabelsInterface,
  entityId: ArdoqId,
  labelsData: OtherLabelsData,
  entityType: APIEntityType,
  i18nLocale: I18nLocale
) => {
  const relevantFormatting = getRelevantLabelFormatting({
    apiEntityType: entityType,
    ...labelsData,
  })?.[0];
  if (!relevantFormatting) {
    return null;
  }

  const fieldName = relevantFormatting.fields?.[0];
  if (!fieldName) {
    return null;
  }

  return (
    fieldLabel({
      labelsInterface,
      modelId: entityId,
      entityFields: labelsData.fields,
      entityType,
      showFieldName: relevantFormatting.showFieldName,
      i18nLocale,
    })(fieldName) ?? null
  );
};
